import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import NewUserInvite from './NewUserInvite'
import MembersList from './MembersList'
import InvitesList from './InvitesList'

import { getAppDomainName } from '../../../features/helpers/getAppDomainName'

import { clearInvitesList, clearMembersList, getInvitesList, getMembersList } from '../../../modules/actions/team'
import { currentUserSelfAccountsListSelector } from '../../../modules/selectors/app'
import { selectedPartnershipSelector } from '../../../modules/selectors/partnerships'

import useCommonStyles from '../../../styles/common/listPage'

function ManageTeam({ selfAccountId, isRightsHolderTeam }) {
  const commonClasses = useCommonStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const currentUserSelfAccountsList = useSelector(currentUserSelfAccountsListSelector)
  const appName = getAppDomainName()

  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const { rights_holder_name: rightsHolderName } = selectedPartnership

  const selfAccountName =
    currentUserSelfAccountsList.find(item => {
      return item.id === selfAccountId
    })?.name || ''

  useEffect(() => {
    // we don't need to use loadMore handlers for members and invites, just load all
    dispatch(getMembersList({ account: selfAccountId, limit: 999 }))
    dispatch(getInvitesList({ accounts: selfAccountId, limit: 999 }))

    return () => {
      dispatch(clearMembersList())
      dispatch(clearInvitesList())
    }
  }, [dispatch, selfAccountId])

  return (
    <>
      <div className={commonClasses.heading}>
        <h3 className={commonClasses.title}>{t(`${selfAccountName} Team`)}</h3>
        <p>
          {isRightsHolderTeam
            ? t(
                `Members listed below will have access to the ${rightsHolderName} ${appName} account, but don’t automatically get access to partner accounts until added directly as users on them also. Team members also need to be users on the ad accounts directly to be able to access campaigns.`
              )
            : t(`Members listed below will have access to the ${selfAccountName} ${appName} account.`)}
        </p>
        <div className={commonClasses.formButtons}>
          <NewUserInvite selfAccountId={selfAccountId} isRightsHolderTeam={isRightsHolderTeam} />
        </div>
      </div>
      <MembersList selfAccountId={selfAccountId} selfAccountName={selfAccountName} />
      <InvitesList />
    </>
  )
}

ManageTeam.propTypes = {
  selfAccountId: PropTypes.number
}

export default ManageTeam
